import posthog from "posthog-js";

posthog.init(process.env.REACT_APP_POSTHOG_KEY, {
  api_host: process.env.REACT_APP_POSTHOG_HOST,
  person_profiles: "identified_only", // only create profiles for identified users
  autocapture: false,                 // we fire all events manually
  capture_pageview: false,            // we track tab navigation ourselves
});

export default posthog;
